export function titleize(value) {
  const str = value == null ? '' : String(value)
  return str.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}
